module.exports = __webpack_public_path__ + "img/884.fa7b3ed5.png";